export default "__VITE_ASSET__fd9404d9__"